import React, { useRef, useState, useEffect } from 'react'

// redux
import { connect } from 'react-redux'

// bootstrap
import {
    Container,
    Spinner
} from 'react-bootstrap'
// icons : feather
import FeatherIcon from 'feather-icons-react';

// react router
import { Link } from 'react-router-dom'

// formik
import {
    useFormik, //hook for functonal components
} from 'formik'

// yup
import * as Yup from 'yup'

// actions
import { setGlobalLoading } from 'redux/actions/actionCommon';

// toast
import { toast } from 'react-toastify'

// apis
import { 
    getTestimonialDetails_API, 
    cancelGetTestimonialDetailsApi,
    editTestimonials_API
} from 'utlis/Apis/Testimonials_API'

// messages
import {
    UNKNOWN_ERROR_OCCURED,
    ERROR_WHILE__NAME,
} from 'utlis/AppMessages/AppMessages'

// use store url
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl'

// includes
import FormContent from './includes/FormContent'
import ImagesUploader from './includes/ImagesUploader'

function Edit(props) {
    // props
    const { 
        authState,
        sideBarVisibility,

        match,
        
        setGlobalLoading
    } = props

    // refs
    const submitBtnRef = useRef(null)

    // states
    const [btnDisable, setBtnDisable] = useState(false)
    const [btnLoading, setBtnLoading] = useState(false)

    const [imageFromTestimonialDetails, setImageFromTestimonialDetails] = useState("")
    const [currentSelectedImage, setCurrentSelectedImage] = useState(null)
    
    // store url
    const [storeUrl] = useStoreUrl()
    // consts
    const { testimonialId } = match?.params

    // initial form values
    const initialFormValues = {
        isImageSelected: null,
        name: "",
        review: "",
        rating: "1",
        designation: "",
        status: "1",
    }

    // form validations
    const formValidationSchema = Yup.object({
        isImageSelected: Yup.boolean().required('This field is required'),
        name: Yup.string().required('This field is required'),
        review: Yup.string().required('This field is required'),
        rating: Yup.string().required('This field is required'),
        designation: Yup.string(),
        status: Yup.string().required('This field is required'),
    })

    // handle form submmision
    const onFormSubmit = values => {
        if (values) {
            // loading
            setGlobalLoading(true)
            setBtnDisable(true)
            setBtnLoading(true)

            // fetching data
            const requiredData = {
                testimonialId,
                image: currentSelectedImage.value,
                name: values.name,
                review: values.review,
                rating: values.rating,
                designation: values.designation,
                status: values.status,
            }
            console.log("requiredData ", requiredData);
            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            editTestimonials_API(headers, requiredData).then(res => {
                const resData = res.data
                console.log("resData ", resData);

                // on success
                if (resData?.success) {
                    // dismissing all the other toasts
                    toast.dismiss();

                    // showing toast message
                    toast.success("Testimonial updated successfully", {
                        autoClose: 2500,
                        onClose: () => {}
                    }) 
                }

                // on error
                if (resData && resData.error) {
                    // dismissing all the other toasts
                    toast.dismiss();

                    // showing toast message
                    toast.error(UNKNOWN_ERROR_OCCURED, {
                        autoClose: 2500
                    })
                }

                // loading
                setGlobalLoading(false)
                setBtnDisable(false)
                setBtnLoading(false)
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} editTestimonials_API `, err.message)
    
                // dismissing all the other toasts
                toast.dismiss();
    
                // showing toast message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // loading
                        setGlobalLoading(false)
                        setBtnDisable(false)
                        setBtnLoading(false)
                    }
                })
            })
        }
    }

    // formik hook
    const formik = useFormik({
        initialValues: initialFormValues,
        validationSchema: formValidationSchema,
        onSubmit: onFormSubmit,
        enableReinitialize: true
    })

    // getting testimonial details
    useEffect(() => {
        if(testimonialId) {
            // loading
            setGlobalLoading(true)

            const headers = {
                "Authorization": `Bearer ${authState.commonToken}`,
                "Api-Token": authState.apiToken,
                "Access-Token": "",
                // "Store-Id": authState.storeId,
            }
            getTestimonialDetails_API(headers, testimonialId).then(res => {
                const resData = res.data
                console.log("resData ", resData);
    
                // on success
                if (resData?.success) {
                    formik.setFieldValue("name", resData.data.name)
                    formik.setFieldValue("review", resData.data.review)
                    formik.setFieldValue("rating", resData.data.rating)
                    formik.setFieldValue("designation", resData.data.designation)
                    formik.setFieldValue("status", resData.data.status)
                    setImageFromTestimonialDetails(resData.data.image)
                }
    
                // on error
                if (resData && resData.error) {
                    // dismissing all the other toasts
                    toast.dismiss();
    
                    // showing toast message
                    toast.error(resData?.message || UNKNOWN_ERROR_OCCURED, {
                        autoClose: 3000
                    })
                }
    
                // loading
                setGlobalLoading(false)
            }).catch(err => {
                console.log(`${ERROR_WHILE__NAME} getTestimonialDetails_API `, err.message)
    
                // dismissing all the other toasts
                toast.dismiss();
    
                // showing toast message
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500,
                    onClose: () => {
                        // loading
                        setGlobalLoading(false)
                    }
                })
            })
    
            return () => {
                cancelGetTestimonialDetailsApi && cancelGetTestimonialDetailsApi()
            }
        }
    }, [
        testimonialId, 
        authState.apiToken, 
        authState.commonToken
    ])

    // handle button submission
    const handleFormSubmission = (ev) => {
        ev.preventDefault()

        // triggering click on submit button
        submitBtnRef.current.click()
    }

    // getting content result
    const getContentResult = data => {
        // setting field content
        formik.setFieldValue("content", data)
    }

    // setting isImageSelected when image is selected by the user
    useEffect(() => {
        if(currentSelectedImage) {
            formik.setFieldValue("isImageSelected", true)
        }
    }, [currentSelectedImage])

    return (
        <section id="app-testimonials__edit" className="st-def-mar-TB page-eorc-wrapper">
            <Container fluid className="st-container">
                {/* BACK BUTTON WRAPPER */}
                <div className="back-button-wrapper st-line-height-0 mb-3">
                    <Link 
                        to={storeUrl + "/catalog/testimonials/"}
                        className="text-decoration-none st-text-primary d-inline-flex align-items-center cursor-pointer st-fs-14 st-fw-600">
                        <FeatherIcon
                            icon="arrow-left"
                            size="16"
                            className="icon me-1" />
                        <span>Back to Testimonials</span>
                    </Link>
                </div>

                <div className="app-testimonials__edit">
                    {/* HEADING WRAPPER */}
                    <div className="app-header-wrapper mb-3">
                        {/* heading */}
                        <p className="app-heading text-capitalize">Edit Testimonial</p>
                        <p className="app-desc">
                            Edit testimonial
                        </p>
                    </div>

                    {/* CONTENT WRAPPER */}
                    <form
                        onSubmit={formik.handleSubmit}
                        noValidate
                        autoComplete="off">
                        <div className="app-content-container">
                            {/* app card */}
                            <div className="app-card mb-3">
                                {/* heading */}
                                <div className="app-header-wrapper heading-sm mb-1">
                                    <p className="app-heading text-capitalize st-text-light">Image <span className="st-fs-12 st-fw-400">(required)</span></p>
                                </div>

                                {/* content */}
                                <div className="app-card-content bg-white border st-border-light st-default-rounded-block pad-20-LR pad-20-T">
                                    <div className="px-0 col-lg-8 col-md-9 col-12">
                                        <ImagesUploader
                                            formik={formik}

                                            imageFromTestimonialDetails={imageFromTestimonialDetails}
                                            currentSelectedImage={currentSelectedImage}
                                            setCurrentSelectedImage={setCurrentSelectedImage}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* app card */}
                            <div className="app-card mb-3">
                                {/* heading */}
                                <div className="app-header-wrapper heading-sm mb-1">
                                    <p className="app-heading text-capitalize st-text-light">Information</p>
                                </div>

                                {/* content */}
                                <div className="app-card-content bg-white border st-border-light st-default-rounded-block pad-20-LR pad-20-T">
                                    <div className="px-0 col-lg-8 col-md-9 col-12">
                                        <FormContent
                                            formik={formik}

                                            getResult={getContentResult}
                                        />
                                    </div>
                                </div>
                            </div>

                            {/* app card : bottom-bar */}
                            <div className={`app-card page-bottom-action-btns ${sideBarVisibility ? "" : "sidebar-expanded"}`}>
                                <div className="app-card-content bg-white border-top st-border-light d-flex align-items-center justify-content-end">
                                    <Link to={storeUrl + "/catalog/testimonials"} className="st-btn st-btn-link no-min-width d-flex align-items-center justify-content-center me-1">
                                        Cancel
                                    </Link>
                                    <button
                                        type="submit"
                                        className={`st-btn st-btn-primary d-flex align-items-center justify-content-center ${(btnDisable || Object.keys(formik.errors).length) ? "disabled" : ""}`}
                                        disabled={btnDisable}
                                        onClick={handleFormSubmission}>
                                        {
                                            btnLoading ? (
                                                <Spinner animation="border" size="sm" />
                                            ) : (
                                                <span>Update</span>
                                            )
                                        }
                                    </button>
                                </div>
                            </div>
                        </div>

                        {/* submit btn */}
                        <button type="submit" ref={submitBtnRef} className="d-none">submit</button>
                    </form>
                </div>
            </Container>
        </section>
    )
}

const getDataFromStore = state => {
    return {
        authState: state.auth,
        sideBarVisibility: state.common.sideBarVisibility
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(Edit)